// extracted by mini-css-extract-plugin
export default {"table":"r3ipTWJI2i7VU_sq_DUj","link":"XxZmG_nnHt9Bv5SDDYBm","reason":"f8CS9YCOwYMshjwHHKrF"};